import { ResourceKind } from 'lib/enum/resource-kind.enum';
import { generateIri } from 'lib/utils/iri';
import { privateApi } from 'services';
import { UserProductItemRole } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchUserProductItemRoles = async (productItemId: string): Promise<UserProductItemRole[]> =>
    privateApi.get<UserProductItemRole[]>(`product-items/${productItemId}/user-roles`);

const createUserProductItemRole = async (
    assigneeId: string,
    productItemId: string,
    roleId: string,
): Promise<UserProductItemRole> =>
    privateApi.post<UserProductItemRole>('user-product-item-roles', {
        user: generateIri(ResourceKind.User, assigneeId),
        productItem: generateIri(ResourceKind.ProductItem, productItemId),
        role: roleId,
    });

const updateUserProductItemRole = async (
    userContextRoleEntityId: string,
    roleId: string,
): Promise<UserProductItemRole> =>
    privateApi.put<UserProductItemRole>(`user-product-item-roles/${userContextRoleEntityId}`, {
        role: roleId,
    });

const deleteUserProductItemRole = async (userContextRoleEntityId: string): Promise<UserProductItemRole> =>
    privateApi.delete<UserProductItemRole>(`user-product-item-roles/${userContextRoleEntityId}`);

export const UserProductItemRoleGateway = {
    fetchUserProductItemRoles,
    createUserProductItemRole,
    updateUserProductItemRole,
    deleteUserProductItemRole,
};

const cancelableFetchUserProductItemRoles = async (productItemId: string): Promise<UserProductItemRole[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<UserProductItemRole[]>(
        `product-items/${productItemId}/user-roles`,
    );

export const CancelableUserProductItemRoleGateway = {
    cancelableFetchUserProductItemRoles,
};
